import { FormSectionTitle } from '@practium/ui';
import tabStyles from '../Tabs/TabPanel.module.css';
import { SimpleDataTable } from '../Tables/SimpleDataTable/SimpleDataTable';
import type { PlanningBudgetMonth, PlanningTableData } from '../../utils/planningTableMapper';
import { formatCurrency } from '../../utils/productCosts';
import styles from './MonthlyBudget.module.css';

interface MonthlyBudgetProps {
	months: PlanningBudgetMonth[];
	activePeriod: string;
	onPeriodChange: (period: string) => void;
	table: PlanningTableData;
}

export const MonthlyBudget = ({ months, activePeriod, onPeriodChange, table }: MonthlyBudgetProps) => (
	<div className={tabStyles.section}>
		<FormSectionTitle>Orçamento mensal</FormSectionTitle>
		<div className={styles.months}>
			{months.map((month) => (
				<button
					key={month.period}
					type="button"
					className={`${styles.month} ${month.period === activePeriod ? styles.monthActive : ''}`}
					onClick={() => onPeriodChange(month.period)}
					aria-pressed={month.period === activePeriod}
				>
					<span className={styles.monthLabel}>{month.label}</span>
					<span className={styles.monthValue}>{formatCurrency(month.total)}</span>
				</button>
			))}
		</div>
		<SimpleDataTable columns={table.columns} rows={table.rows} />
	</div>
);
